import { useGateValue } from '@statsig/react-bindings';

import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const MachineLearningJumbotron = (): JSX.Element => {
  const ouraAdvisorRollout = useGateValue('oura_advisor_rollout');

  if (!ouraAdvisorRollout) return <></>;

  return (
    <section data-cy="science-and-research-blurb" className="md:pt-16 xl:pb-8">
      <LandingPageJumbotron
        description="science_and_research_ai_learn_description"
        title="science_and_research_ai_learn_title"
      />
    </section>
  );
};

export default MachineLearningJumbotron;
